import React from 'react';
import AccordionList from '../../AccordionList/AccordionList';
import Tag from 'selfly-ui-react/dist/components/Tag';
import { Icon, Accordion } from 'selfly-ui-react';

import { readableTimeWithTextMonth } from '../../../utils/readableTime';

import './DeviceTestResults.scss';

export default function DeviceTestResults(props) {
    const { device } = props;

    const results = device && device.fatResults ? device.fatResults : null;

    const columns = [
        {
            key: 'name',
            title: 'Name',
            onClickOpenChildren: true,
            className: 'auto-small mini-text',
            content: item => {
                const nameText = typeof item.name === 'string' && item.name.length > 0 ? item.name : item.id;
                return (
                    <>
                        <span>{nameText}</span>
                    </>
                );
            },
        },
        {
            key: 'status',
            title: 'Status',
            onClickOpenChildren: true,
            content: (val, item) => {
                if (val.status === 'PASS') {
                    return <span style={{ color: 'green' }}>{val.status}</span>;
                } else if (val.status === 'SKIPPED') {
                    return <span style={{ color: '#FFA500' }}>{val.status}</span>;
                }
                return <span style={{ color: 'red' }}>{val.status}</span>;
            },
            className: 'fix-100  mini-text',
        },
        {
            key: '',
            title: 'Steps',
            className: 'fix-mini mini-text',
            onClickOpenChildren: true,
            content: item => {
                const stepsCount = item.steps && item.steps.length > 0 ? item.steps.length : null;
                return (
                    <>
                        {stepsCount && (
                            <span className="flexible-content-center">
                                <Tag>
                                    {stepsCount} <Icon>arrow_drop_down</Icon>
                                </Tag>
                            </span>
                        )}
                    </>
                );
            },
        },
    ];

    const childColumns = [
        {
            key: 'id',
            title: 'Id',
            className: 'auto-small mini-text',
            content: item => {
                const nameText = typeof item.id === 'string' && item.id.length > 0 ? item.id : '';
                return (
                    <>
                        <span>{nameText}</span>
                    </>
                );
            },
        },
        {
            key: 'status',
            title: 'Status',
            className: 'fix-100  mini-text',
            content: (val, item) => {
                if (val.status === 'PASS') {
                    return <span style={{ color: 'green' }}>{val.status}</span>;
                } else if (val.status === 'SKIPPED') {
                    return <span style={{ color: '#FFA500' }}>{val.status}</span>;
                } else if (val.status === 'RUNNING') {
                    return <span style={{ color: '#FFA500' }}>{'SKIPPED'}</span>;
                }
                return <span style={{ color: 'red' }}>{val.status}</span>;
            },
        },
        {
            key: 'message',
            title: '',
            className: 'fix-large mini-text',
            content: item => {
                const message = item.details ? item.details.message : item.error ? item.error.message : null;
                return <>{message && <span>{message}</span>}</>;
            },
        },
    ];

    if (results === undefined || results === null || (Array.isArray(results) && results.length < 1)) {
        return (
            <div className="test-results-files">
                <h2 className="no-fat-results">No factory acceptance results are available.</h2>
            </div>
        );
    }

    return (
        <>
            <div className="test-results-files">
                {Array.isArray(results) &&
                    results.length > 0 &&
                    results.map(item => {
                        return (
                            <Accordion title={`${readableTimeWithTextMonth(item.date)}`} icon="receipt" key={item.date}>
                                {Array.isArray(item.results) && item.results.length > 0 ? (
                                    <AccordionList
                                        className="smaller-text"
                                        data={item.results}
                                        idkey="id"
                                        colkeys={columns}
                                        childkey="steps"
                                        childColKeys={childColumns}
                                    />
                                ) : (
                                    <div className="test-results-files">
                                        <h2 className="no-fat-results">No detail is available for this test run.</h2>
                                    </div>
                                )}
                            </Accordion>
                        );
                    })}
            </div>
        </>
    );
}
